import ScrollToTop from '../../components/ScrollToTop';
import HomePageHeader from '../../components/HomePageHeader';
import CTA from '../../components/CTA';
import AboutSection from '../../components/AboutSection';
// import ApproachSection from '../../components/Approach';
import HomeServices from '../../components/HomeServices';
import HomeServicesTwo from '../../components/HomeServicesTwo';
import SafteryAssurance from '../../components/SafteryAssurance';
// import WhyUs from '../../components/WhyUs';
import Testimonial from '../../components/Testimonial';
import ContactCta from '../../components/ContactCta';
import WhatsAppUs from '../../components/WhatsAppUs';
import '../../index.css';
import './home.css';


const Home = () => {
    return (
        <>
            <ScrollToTop/>
            <HomePageHeader />
            <CTA />
            <AboutSection />
            {/* <ApproachSection /> */}
            <HomeServices />
            <HomeServicesTwo />
            <SafteryAssurance/>
            {/* <WhyUs /> */}
            <Testimonial />
            <ContactCta />
            <WhatsAppUs/>
        </>
    )
}

export default Home